import styled from 'styled-components';
import indents from '../../../../../../../constants/js/indents.js';
import { textSizeStyles } from '../../../../../../../mixins/text/textSizeWeight';
import { getColorStylesLegacy } from '../../../../../../../mixins/text/textColorLegacy';
export const StyledContainer = styled.label.withConfig({
  componentId: "InputRegular__sc-84ko4s-0"
})(["display:block;"]);
export const StyledFieldName = styled.div.withConfig({
  componentId: "InputRegular__sc-84ko4s-1"
})(["padding-bottom:", ";", " ", ""], indents.indentXS, textSizeStyles('fs14'), getColorStylesLegacy('secondary'));